export default __webpack_public_path__ + "static/media/board-btn-icon.f34fcaae.svg";